import React from "react";
import "./App.css";
import { IoIosArrowDown } from "react-icons/io";
import { CgProfile } from "react-icons/cg";
import { IconButton } from "@mui/material";
import { BsThreeDots } from "react-icons/bs";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { getRandomComments, getRandomUsernames } from "./Data";
import Profile from "./icons/Purple Profile.png";

const COMMENT_DATA = [
  { username: "evan.chen", content: "Wow! This one is chic." },
  {
    username: "hannahhcha",
    content: "I like this one a lot better than the other!",
  },
  {
    username: "nancy_hoang",
    content: "This one is so business casual! Perfect for work.",
  },
  { username: "soracha", content: "This one is giving girlboss!!" },
  { username: "hana.dao", content: "Omg this one is the one!!" },
];

function Comment(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="Comment-container">
      <div className="Comment-profile">
        <img style={{ width: "2rem", height: "rem" }} src={Profile} alt="" />
        <div>{props.username}</div>
      </div>
      <div style={{ flexGrow: 2 }}>{props.content}</div>
      <IconButton onClick={handleClick}>
        <BsThreeDots />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleClose}>Report Comment</MenuItem>
      </Menu>
    </div>
  );
}

function CommentSection(props) {
  if (!props.open) {
    return null;
  }

  const comments = getRandomComments(props.dataKey, props.numComments);
  const usernames = getRandomUsernames(props.dataKey, props.numComments);

  return (
    <div className="CommentSection-container">
      <div className="CommentSection-titlebar">
        <div style={{ width: 48 }}></div>
        <div>Comments ({comments.length})</div>
        <IconButton onClick={() => props.setOpen(false)}>
          <IoIosArrowDown size="3rem" />
        </IconButton>
      </div>
      <div className="CommentSection-content">
        {comments.map((data, i) => (
          <Comment content={data} username={usernames[i]} />
        ))}
      </div>
    </div>
  );
}

export default CommentSection;
